import { render, staticRenderFns } from "./EditAttribute.vue?vue&type=template&id=2696ea98&scoped=true"
import script from "./EditAttribute.vue?vue&type=script&lang=js"
export * from "./EditAttribute.vue?vue&type=script&lang=js"
import style0 from "./EditAttribute.vue?vue&type=style&index=0&id=2696ea98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2696ea98",
  null
  
)

export default component.exports